import React from 'react';

import { MdClose } from 'react-icons/md';
import { Text } from 'scouting-ui/lib';

import Img from '@shared/components/Img/Img';

import BoyScout from '../../../../assets/images/FleurDeLis.svg';
import styles from './AvatarPill.less';

function AvatarPill({
  person,
  onClick,
}: {
  person: {
    pictureUrl?: string;
    firstName: string;
    lastName: string;
    userId: number;
  };
  onClick: (userId: number) => void;
}) {
  const { pictureUrl, firstName, lastName, userId } = person;

  return (
    <div className={styles.pill}>
      {pictureUrl ? (
        <Img
          className={styles.avatar}
          src={pictureUrl}
          height={24}
          title="Profile Picture"
        />
      ) : (
        <BoyScout className={styles.placeholderIcon} />
      )}
      <Text font={'body-caption'} className={styles.name}>
        {firstName} {lastName}
        <button onClick={() => onClick(userId)} className={styles.removeButton}>
          <MdClose className={styles.removeIcon} />
        </button>
      </Text>
    </div>
  );
}

export default AvatarPill;
